// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RINfL","placeholdersHeader":"styles_placeholdersHeader__2UZaV","editorStyle":"styles_editorStyle__1F0a0","placeholdersBox":"styles_placeholdersBox__2oJku"};